module.exports = __webpack_public_path__ + "img/20190803105855768.276052a6.png";